import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isString } from 'lodash';
import type { Duration } from 'luxon';
import { DateTime } from 'luxon';
import type { Observable } from 'rxjs';
import { interval, map, startWith } from 'rxjs';

type DurationDate = string | DateTime;

@Pipe({
  name: 'diff',
})
export class DiffPipe implements PipeTransform {
  public transform(a: 'now', b: DurationDate | 'now'): Observable<Duration>;
  public transform(a: DurationDate | 'now', b: 'now'): Observable<Duration>;
  public transform(a: DurationDate, b: DurationDate): Duration;

  public transform(
    a: DurationDate | 'now',
    b: DurationDate | 'now',
  ): Duration | Observable<Duration> {
    if (a === 'now' || b === 'now') {
      return interval(1000).pipe(
        startWith(0),
        map(() => DateTime.now()),
        map((now) => {
          a = a === 'now' ? now : this.getDateTime(a);
          b = b === 'now' ? now : this.getDateTime(b);
          return a.diff(b);
        }),
      );
    }

    return this.getDateTime(a).diff(this.getDateTime(b));
  }

  private getDateTime(date: DurationDate): DateTime {
    if (isString(date)) return DateTime.fromISO(date);
    return date;
  }
}
